import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { renderMatches, useParams, useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import BusinessIcon from '@mui/icons-material/Business';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';
import LinkIcon from '@mui/icons-material/Link';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PublicIcon from '@mui/icons-material/Public';
import ReplyIcon from '@mui/icons-material/Reply';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Divider } from '@mui/material';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import { amber, blue, teal } from '@mui/material/colors';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Modal from '@mui/material/Modal';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import DOMPurify from 'dompurify';
import { useSnackbar } from 'notistack';
import QRCode from 'qrcode.react';

import DemographicDataForm from '../../components/DemographicDataForm/DemographicDataForm';
import MyCard from '../../components/MyCard/MyCard';
import MyLoader from '../../components/MyLoader/MyLoader';
import MyPageHeader from '../../components/MyPageHeader/MyPageHeader';
import { currentCompanySelected } from '../../features/companies/companiesSlice';
import {
  fetchSurveyByIdAndCompanyId,
  selectCurrentSurvey,
  selectSurveysStatus,
} from '../../features/surveys/surveysSlice';
import IconSidebar from '../../Layout/IconSidebar/IconSidebar';
import Navbar from '../../Layout/Navbar/Navbar';
import { getJarvisReviewStatusAPI, requestJarvisReviewAPI } from '../../services/jarvisReview.service';
import { dispatchJourneyMailAPI } from '../../services/sendInvitation.service';
import client, { API } from '../../utils/axiosInstance';
import api from '../../utils/axiosInstance';
import { formatearFechas } from '../../utils/fechaCierre';
import NotFoundMessage from '../AnswerSurvey/components/NotFoundMessage/NotFoundMessage';

import DuplicarEncuestaContent from './components/DuplicarEncuestaContent';
import RespondentsDialog from './components/RespondentsDialog';
import SendInvitationDialog from './components/SendInvitationDialog/SendInvitationDialog';
import { SendInvitationDialogWhatsapp } from './components/SendInvitationWhatsapp/SendInvitationDialogWhatsapp';
import StaticsEmails from './components/StatiticsEmails/StaticsEmails';
import {
  templateFromSurveyAllCompanies,
  templateFromSurveyByCompany,
} from './services/services';
import { ConfirmDialog } from './ConfirmDialog';
import CustomDialog from './CustomDialog';
import { SelectSurveyDuplicateTemplate } from './SelectSurveyDuplicateTemplate';

import styles from './SurveyDetailPage.module.css';

// survey options
const options = [
  {
    option: 'Editar',
    icon: <EditIcon />,
  },
  {
    option: 'Duplicar',
    icon: <ContentCopyIcon />,
  },
  {
    option: 'Generar plantilla (todos)',
    icon: <PublicIcon />,
  },
  {
    option: 'Generar plantilla (empresa)',
    icon: <BusinessIcon />,
  },
  {
    option: 'Borrar',
    icon: <DeleteIcon />,
  },
];

  const quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: [1, 2, 3, false] }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ['link'],
      ['clean'],
    ],
  };

/**
 * Survey Detail Page Component.
 *
 * @returns {JSX.Element}
 * @constructor
 */
const SurveyDetailPage = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const { id: surveyId } = useParams();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const surveysStatus = useSelector((state) => selectSurveysStatus(state));
  const currentSurvey = useSelector((state) => selectCurrentSurvey(state));
  const currentCompany = useSelector((state) => state.companies.currentCompany);
  const [linkCopied, setLinkCopied] = useState(false);
  const [jarvisDisabled, setJarvisDisabled] = useState(false);
  const [jarvisDiesAt, setJarvisDiesAt] = useState(null);

  useEffect(() => {
    if (!surveyId) return;
    getJarvisReviewStatusAPI(surveyId)
      .then(({ data }) => {
        setJarvisDisabled(Boolean(data.hasLiveToken));
        setJarvisDiesAt(data.diesAt || null);
      })
      .catch(() => {
        setJarvisDisabled(false);
      });
  }, [surveyId]);

  const handleJarvisReview = async () => {
    try {
      const { data } = await requestJarvisReviewAPI(surveyId);
      setJarvisDisabled(true);
      setJarvisDiesAt(data.diesAt || null);
      enqueueSnackbar('Correo enviado a Jarvis', { variant: 'success' });
    } catch (error) {
      const msg =
        error?.response?.status === 409
          ? 'Ya hay una revisión en curso'
          : 'No se pudo iniciar la revisión con Jarvis';
      enqueueSnackbar(msg, { variant: 'error' });
    }
  };
  const [reminderSent, setReminderSent] = useState(false);
  const [isSendingInvitation, setIsSendingInvitation] = useState(false);
  const [isSendingReminder, setIsSendingReminder] = useState(false);
  const [isInvitationDialogOpen, setIsInvitationDialogOpen] = useState(false);
  const [dispatchMessage, setDispatchMessage] = useState('');
  const [dispatchEmailMask, setDispatchEmailMask] = useState('');
  const [dispatchEmailSubject, setDispatchEmailSubject] = useState('');
  const [showDemographicData, setShowDemographicData] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [errorReminderDay, setErrorReminderDay] = useState(null);
  const [reminderDays, setReminderDays] = useState('60');
  const reminderDaysRef = useRef(reminderDays);
  const [openDialogs, setOpenDialogs] = useState({});
  const [switchChecked, setSwitchChecked] = useState(null); // Estado del switch
  const switchCheckedReminderDaysRef = useRef(switchChecked);
  const qrRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);
  const [visibility, setVisibility] = useState(null);
  const [visibilitySelectCompanies, setVisibilityCompanies] = useState(false);
  const [deleteMode, setDeleteMode] = useState(null); // 'all' | 'one'
  const [selectedUserId, setSelectedUserId] = useState('');
  const [dialogStep, setDialogStep] = useState(null); // 0: selección, 1: correo
  const [userEmails, setUserEmails] = useState([]);
  const [respondedUsers, setRespondedUsers] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [selectedSurveyUserIds, setSelectedSurveyUserIds] = useState([]);
  const [allUsersSurvey, setAllUsersSurvey] = useState([]);
const [canConfirm, setCanConfirm] = useState(false);
  const duplicateSelectionRef = useRef({ companyId: '', mapId: '' });
  // flags, tags and counters.
  const [chips, setChips] = useState([
    {
      id: 1,
      text: 'Encuesta anónima',
      backgroundColor: blue[200],
      color: blue[900],
      icon: <AdminPanelSettingsIcon style={{ color: blue[900] }} />,
    },
    {
      id: 2,
      text: 'Usuarios invitados',
      backgroundColor: amber[100],
      color: amber[800],
      icon: <EmailIcon style={{ color: amber[800] }} />,
      counter: 0,
    },
    {
      id: 3,
      text: 'Respuestas',
      backgroundColor: teal['A100'],
      color: teal[900],
      icon: <ReplyIcon style={{ color: teal[900] }} />,
      counter: 0,
    },
  ]);
  const [qrPath, setQrPath] = useState(null);

  const [searchParams] = useSearchParams();
  const isOpenSendMail = searchParams.get('sendMail') === 'true';

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const [openDialogEmail, setOpenDialogEmail] = useState(false);
  const [openRespondentsDialog, setOpenRespondentsDialog] = useState(false);

  const handleOpenDialogEmails = () => {
    setOpenDialogEmail(true);
  };

  const handleCloseDialogEmails = () => {
    setOpenDialogEmail(false);
  };

  const navigate = useNavigate();
  /**
   * Handle click menu for open survey options.
   *
   * @param event
   */
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleDuplicateSelectionChange = (val) => {
    duplicateSelectionRef.current = val;
    // Actualiza el canConfirm del dialog específico
    setOpenDialogs((prev) => {
      const dialogId = Object.keys(prev).find((k) => prev[k].isOpen);
      if (!dialogId) return prev;
      return {
        ...prev,
        [dialogId]: { ...prev[dialogId], canConfirm: !!val.mapId },
      };
    });
  };
  /**
   * Handle close menu for close survey options.
   */

  const handleCloseMenu = (option) => {
    if (option === 'Borrar') {
      handleOpenDialog(
        generateSurveyId(),
        'El ejecutar esta opción se eliminará la encuesta',
        () => handleDeleteSurvey(currentSurvey.response.surveyId),
        false,
      );
    }
    if (option === 'Editar') {
      navigate(
        `/journey/edit-survey/${currentSurvey.response.surveyId}?isTemplate=False&isEdit=true`,
      );
    }
    if (option === 'Duplicar') {
      const dialogId = generateSurveyId();
      handleOpenDialog(
        dialogId,
        <DuplicarEncuestaContent
          onSelectionChange={handleDuplicateSelectionChange}
          currentCompany={currentCompany}
        />,
        () => {
          handleDuplicateSurvey(
            currentSurvey.response.surveyId,
            duplicateSelectionRef.current.companyId,
            duplicateSelectionRef.current.mapId,
          );
          handleCloseDialog(dialogId);  
        },
        false,
        false,
      );
    }
    if (option === 'Generar plantilla (todos)') {
      const id = generateSurveyId();
      handleOpenDialog(
        id,
        'El ejecutar esta opción se generará una plantilla para todas las empresas',
        () => {
          handleTemplateFromSurveyAll(
            currentSurvey.response.surveyId,
            currentCompany.id,
          );
          handleCloseDialog(id);
        },
        false,
      );
    }
    if (option === 'Generar plantilla (empresa)') {
      setVisibilityCompanies(true);
      /*
      handleTemplateFromSurveyByCompany(
        currentSurvey.response.surveyId,
        currentCompany.id,
        currentCompany.id
      );*/
    }
    setAnchorEl(null);
  };

  const handleDuplicateSurvey = async (idSurvey, companyId, mapId) => {
    if (!currentSurvey || !companyId || !mapId) return;
    try {
      const response = await client.post(
        `CloneJourney/${idSurvey}/${companyId}/${mapId}`,
      );
      if (response.status === 200) {
        enqueueSnackbar('Encuesta duplicada satisfactoriamente', {
          variant: 'success',
          autoHideDuration: 2000,
        });
      }
    } catch (error) {
      enqueueSnackbar('Error al duplicar la encuesta', {
        variant: 'error',
        autoHideDuration: 2000,
      });
    }
  };

  const handleTemplateFromSurveyAll = async (surveyId, currentCompany) => {
    try {
      enqueueSnackbar(
        'Creando plantilla para todas las empresas por favor espere.',
        {
          variant: 'info',
        },
      );
      const response = await templateFromSurveyAllCompanies(
        surveyId,
        currentCompany,
      );
      if (response.status === 200) {
        enqueueSnackbar(
          'Plantilla creada para todas las empresas correctamente.',
          {
            variant: 'success',
          },
        );
      }
    } catch (error) {
      enqueueSnackbar(
        'Hubo un error al crear la plantilla para todas las empresas',
        {
          variant: 'error',
        },
      );
    }
  };

  const handleTemplateFromSurveyByCompany = async (
    surveyId,
    currentCompany,
  ) => {
    try {
      enqueueSnackbar(
        'Creando plantilla para todas las empresas por favor espere.',
        {
          variant: 'info',
        },
      );
      const response = await templateFromSurveyByCompany(
        surveyId,
        currentCompany,
        currentCompany,
      );
      if (response.status === 200) {
        enqueueSnackbar(
          'Plantilla creada para todas las empresas correctamente.',
          {
            variant: 'success',
          },
        );
      }
    } catch (error) {
      enqueueSnackbar(
        'Hubo un error al crear la plantilla para todas las empresas',
        {
          variant: 'error',
        },
      );
    }
  };

  const handleDeleteSurvey = async (idSurvey) => {
    if (!currentSurvey) {
      return;
    }

    try {
      const response = await client.delete(`deleteSurvey/${idSurvey}`);
      if (response.status === 200) {
        setSnackbarMessage('Encuesta eliminada satifactoriamente');
        setOpenSnackbar(true);
        setAlertType('success');

        setTimeout(() => {
          navigate('/journey');
        }, 1000);
      }
    } catch (error) {
      setSnackbarMessage('Hubo un error al momento de eliminar la encuesta');
      setOpenSnackbar(true);
      setAlertType('error');
    }
  };

  /**
   * Open survey in new tab.
   *
   * @param event
   */

  const handleClickDownload = async (event) => {
    event.preventDefault();

    const companyId = userInfo.Company;

    try {
      const response = await client.get(
        `JourneyDownloadFile/${companyId}/${surveyId}`,
        {
          responseType: 'blob', // Indica que se espera un archivo binario (como un PDF, imagen, etc.)
        },
      );
      const filename = response.headers['content-disposition']
        .split('filename=')[1]
        .split(';')[0]
        .replace(/"/g, '');
      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // Aquí puedes especificar el nombre del archivo
      document.body.appendChild(link);
      link.click();

      // Limpiar el enlace temporal después de la descarga
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  };

  const handleClickDownloadQR = async () => {
    try {
      const response = await client.get(`qr/download-survey-qr/${surveyId}`, {
        responseType: 'blob',
      });
      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'QR_Code.png';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error descargando QR:', error);
      enqueueSnackbar('Error al descargar el código QR', {
        variant: 'error',
        autoHideDuration: 2000,
      });
    }
  };

const generateCodeQR = async () => {
  try {
    const response = await client.post(
      `qr/generate-survey-qr/${surveyId}`
    );

    if (response.status === 200) {
      const newQr = response.data.path;
      // 🔥 Forzar que React re-renderice y evitar caché
      setQrPath(newQr);

      enqueueSnackbar('Código QR generado satisfactoriamente', {
        variant: 'success',
        autoHideDuration: 2000,
      });

    } else {
      enqueueSnackbar('Error al generar el código QR', {
        variant: 'error',
        autoHideDuration: 2000,
      });
    }
  } catch (error) {
    enqueueSnackbar('Error al generar el código QR', {
      variant: 'error',
      autoHideDuration: 2000,
    });
  }
};

  /**
   * Copy survey url.
   *
   * @param event
   */
  const handleClickCopyUrl = (event) => {
    event.preventDefault();

    navigator.clipboard.writeText(currentSurvey.response.link);
    setLinkCopied(true);
  };

  /**
   * Copy survey url.
   *
   * @param event
   */
  const handleClickCopyUrlWhatsApp = (event) => {
    event.preventDefault();

    navigator.clipboard.writeText(
      `https://wa.me/573007038902?text=Hola quisiera responder la encuesta ${currentSurvey.response.surveyName}`,
    );
    setLinkCopied(true);
  };

  /**
   * Handle close snackbar.
   */
  const handleCloseSnackbar = () => {
    setLinkCopied(false);
    setReminderSent(false);
  };

  const createRequestId = () =>
    window.crypto?.randomUUID?.() ||
    `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  const getDefaultDispatchMessage = () =>
    currentSurvey?.response?.emailMessage ||
    currentSurvey?.response?.EmailMessage ||
    currentSurvey?.response?.messageMail ||
    currentSurvey?.response?.MessageMail ||
    '';

  const getDefaultDispatchEmailMask = () =>
    currentSurvey?.response?.emailMAsk ||
    currentSurvey?.response?.emailMask ||
    currentSurvey?.response?.EmailMask ||
    currentSurvey?.response?.mailMask ||
    currentSurvey?.response?.MailMask ||
    '';

  const getDefaultDispatchEmailSubject = () =>
    currentSurvey?.response?.emailSubject ||
    currentSurvey?.response?.EmailSubject ||
    currentSurvey?.response?.mailSubject ||
    currentSurvey?.response?.MailSubject ||
    '';

  const setDefaultDispatchMailContent = () => {
    setDispatchMessage(getDefaultDispatchMessage());
    setDispatchEmailMask(getDefaultDispatchEmailMask());
    setDispatchEmailSubject(getDefaultDispatchEmailSubject());
  };

  const buildDispatchPayload = (tipo, extra = {}) => ({
    SurveyId: parseInt(surveyId, 10),
    CompanyId: userInfo.Company,
    Tipo: tipo,
    RequestId: createRequestId(),
    EmailMask: getDefaultDispatchEmailMask(),
    EmailSubject: getDefaultDispatchEmailSubject(),
    Message: getDefaultDispatchMessage(),
    ...extra,
  });

  const openInvitationDispatchDialog = () => {
    setDefaultDispatchMailContent();
    setIsInvitationDialogOpen(true);
  };

  const sendInvitationDispatch = async (_idSurvey, _dialogPosition, mailContent = {}) => {
    if (isSendingInvitation) return;

    setIsSendingInvitation(true);
    try {
      const response = await dispatchJourneyMailAPI(
        buildDispatchPayload('Envio', {
          EmailMask: mailContent.emailMask,
          EmailSubject: mailContent.emailSubject,
          Message: mailContent.message,
        }),
      );
      const result = response?.data?.resultado ?? response?.data?.Resultado ?? response?.data;
      const omittedByAntiBounce =
        result?.omitidosPorAntirebote ??
        result?.OmitidosPorAntirebote ??
        0;

      enqueueSnackbar('Invitaciones enviadas satisfactoriamente', {
        variant: 'success',
        autoHideDuration: 2500,
      });

      if (omittedByAntiBounce > 0) {
        enqueueSnackbar(
          `${omittedByAntiBounce} destinatarios fueron omitidos para evitar envíos duplicados recientes.`,
          { variant: 'warning', autoHideDuration: 5000 },
        );
      }
      setIsInvitationDialogOpen(false);
    } catch (error) {
      enqueueSnackbar(
        error?.response?.data?.Mensaje ||
          'Error al enviar invitaciones. Intenta más tarde o comuníquese con HelpDesk',
        { variant: 'error', autoHideDuration: 3500 },
      );
    } finally {
      setIsSendingInvitation(false);
    }
  };

  /**
   * Send reminder to users.
   *
   * @param event
   */
  const sendReminder = async (idSurvey, dialogPosition, mailContent = {}) => {
    if (isSendingReminder) return;

    const currentReminderDays = reminderDaysRef.current.trim(); // Usar el valor del ref

    if (
      (currentReminderDays === '' || currentReminderDays == 0) &&
      !switchCheckedReminderDaysRef.current
    ) {
      setErrorReminderDay(true);
      return; // Sal de la función
    }
    handleCloseDialog(dialogPosition);
    setIsSendingReminder(true);
    try {
      if (!currentSurvey.response.is360) {
        // Sin OverrideAntiSpam: el backend rechaza un segundo recordatorio en menos de 5 min.
        await dispatchJourneyMailAPI(
          buildDispatchPayload('Recordatorio', {
            LimitDays: switchCheckedReminderDaysRef.current
              ? null
              : Number(currentReminderDays),
            Force: true,
            EmailMask: mailContent.emailMask,
            EmailSubject: mailContent.emailSubject,
            Message: mailContent.message,
          }),
        );
      } else {
        const url = `${API}SendReminder360/${surveyId}`;
        await client.get(url);
      }
      setReminderSent(true);
    } catch (error) {
      enqueueSnackbar(
        error?.response?.data?.Mensaje ||
          'Error al enviar recordatorio. Intenta más tarde o comuníquese con HelpDesk',
        { variant: 'error', autoHideDuration: 3500 },
      );
    } finally {
      setIsSendingReminder(false);
    }
  };

  /**
   * Handle change show demographic data.
   *
   * @param event
   */
  const handleChangeShowDemographicData = (event) => {
    setShowDemographicData(event.target.checked);
  };

  /**
   * Dialog for Delete anwser survey
   *
   *
   *
   * **/
  const handleOpenDialog = (id, ...args) => {
    setOpenDialogs((prevDialogs) => ({
      ...prevDialogs,
      [id]: {
        isOpen: true,
        message: args[0],
        consume: args[1],
        needConfirm: args[2],
        confirmationInput: args[3],
        canConfirm: args[4],
        showDispatchMessage: args[5],
      },
    }));
  };

  const handleCloseDialog = (id) => {
    setOpenDialogs((prevDialogs) => ({
      ...prevDialogs,
      [id]: {
        ...prevDialogs[id], // Mantén las otras propiedades como `message` o `loading`
        isOpen: false, // Solo actualiza el estado `isOpen` a `false` para cerrar el diálogo
      },
    }));
  };

  const handleConfirmAction = async (idSurvey, dialogPosition) => {
    try {
      // Aquí haces la acción deseada, como un consumo de API
      handleCloseDialog(dialogPosition);
      const response = await client.delete(`DeleteAnswers/${idSurvey}`);
      if (response.status === 200) {
        enqueueSnackbar('Repuestas eliminadas satisfactoriamente', {
          variant: 'success',
          autoHideDuration: 2000,
        });
      }
    } catch (error) {
      enqueueSnackbar('Error al eliminar respuestas encuesta', {
        variant: 'error',
        autoHideDuration: 2000,
      });
    }
  };

  const handleAllUserDelete = async (idSurvey, dialogPosition) => {
    try {
      // Aquí haces la acción deseada, como un consumo de API
      handleCloseDialog(dialogPosition);
      const response = await client.delete(`Survey/Users?surveyId=${idSurvey}`);
      if (response.status === 200) {
        enqueueSnackbar('Repuestas eliminadas satisfactoriamente', {
          variant: 'success',
          autoHideDuration: 2000,
        });
      }
    } catch (error) {
      enqueueSnackbar('Error al eliminar respuestas encuesta', {
        variant: 'error',
        autoHideDuration: 2000,
      });
    }
  };

  const fetchAllUserSurvey = async () => {
    try {
      const response = await client.get(`AllUsers/${surveyId}`);
      setAllUsersSurvey(response.data); // Asume que devuelve array de strings
    } catch (error) {
      console.error('Error al obtener correos:', error);
    }
  };

  const fetchAllUserRespondent = async () => {
    try {
      const response = await client.get(`respondents/${surveyId}`);
      setRespondedUsers(response.data); // Asume que devuelve array de strings
    } catch (error) {
      console.error('Error al obtener correos:', error);
    }
  };

  const handleOpenDeleteDialog = () => {
    setDialogStep(0);
    setDeleteMode(null);
  };

  const handleSelectDeleteOption = (option) => {
    switch (option) {
      case 'all':
        handleCloseDialog(); // si es "todo", cerramos y ejecutamos
        handleOpenDialog(
          'Confirmación',
          'Al ejecutar esta acción se borrarán todas las respuestas de la encuesta.',
          () => handleConfirmAction(surveyId, 'Confirmación'),
          true,
        ); // Ya implementado
        break;
      case 'delete-responses':
        setDialogStep(1); // Mostrar campo de correo para borrar respuestas
        break;
      case 'delete-all-user':
        handleCloseDialog(); // si es "todo", cerramos y ejecutamos
        handleOpenDialog(
          'Confirmación',
          'Al ejecutar esta acción se borrarán todas los usuarios y respuestas de la encuesta.',
          () => handleAllUserDelete(surveyId, 'Confirmación'),
          true,
        ); // Ya implementado
        break;
      case 'delete-user':
        setDialogStep(2); // Mostrar campo de correo para eliminar usuario
        break;
    }
  };

  const handleDeleteAnswerUsers = async () => {
    if (selectedUserIds.length === 0) {
      enqueueSnackbar('Por favor selecciona al menos un usuario', {
        variant: 'warning',
        autoHideDuration: 2000,
      });
      return;
    }

    try {
      // Crear array de promesas para eliminar cada usuario
      const deletePromises = selectedUserIds.map((userId) =>
        client.delete(`UserAnswer?idAnswer=${userId}`),
      );

      // Ejecutar todas las eliminaciones en paralelo
      await Promise.all(deletePromises);

      const userCount = selectedUserIds.length;
      enqueueSnackbar(
        `${userCount} respuesta${userCount > 1 ? 's' : ''} eliminada${
          userCount > 1 ? 's' : ''
        } exitosamente`,
        {
          variant: 'success',
          autoHideDuration: 3000,
        },
      );

      // Actualizar los datos
      await fetchAllUserRespondent();
      await fetchAllUserSurvey();

      // Limpiar estado y cerrar diálogo
      setSelectedUserIds([]);
      setDialogStep(null);
    } catch (error) {
      console.error('Error al eliminar las respuestas:', error);
      enqueueSnackbar('Error al eliminar algunas respuestas de usuarios', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }
  };

  const handleDeleteUsersFromSurvey = async () => {
    if (selectedSurveyUserIds.length === 0) {
      enqueueSnackbar('Por favor selecciona al menos un usuario', {
        variant: 'warning',
        autoHideDuration: 2000,
      });
      return;
    }

    try {
      // Crear array de promesas para eliminar cada usuario
      const deletePromises = selectedSurveyUserIds.map((userId) => {
        const encodedUserId = encodeURIComponent(userId);
        return client.delete(`UserFomSurvey?idAnswer=${encodedUserId}`);
      });

      // Ejecutar todas las eliminaciones en paralelo
      await Promise.all(deletePromises);

      const userCount = selectedSurveyUserIds.length;
      enqueueSnackbar(
        `${userCount} usuario${userCount > 1 ? 's' : ''} eliminado${
          userCount > 1 ? 's' : ''
        } de la encuesta exitosamente`,
        {
          variant: 'success',
          autoHideDuration: 3000,
        },
      );

      // Actualizar los datos
      await fetchAllUserRespondent();
      await fetchAllUserSurvey();

      // Limpiar estado y cerrar diálogo
      setSelectedSurveyUserIds([]);
      setDialogStep(null);
    } catch (error) {
      console.error('Error al eliminar usuarios de la encuesta:', error);
      enqueueSnackbar('Error al eliminar algunos usuarios de la encuesta', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }
  };

  /** Vuelve a pedir la encuesta para que "Usuarios invitados" muestre la audiencia recién cargada. */
  const refrescarEncuesta = () =>
    dispatch(fetchSurveyByIdAndCompanyId({ companyId: userInfo.Company, surveyId }));

  const handleNavigateJourney = () => {
    navigate('/journey');
  };
  // component did mount
  useEffect(() => {
    /**
     * Fetch current survey.
     *
     * @returns {Promise<void>}
     */
    const fetchCurrentSurvey = async () => {
      if (surveysStatus === 'loading') {
        return;
      }

      const companyId = userInfo.Company;

      await dispatch(fetchSurveyByIdAndCompanyId({ companyId, surveyId }));
    };

    fetchCurrentSurvey();
  }, [dispatch, surveyId, currentCompany, respondedUsers, allUsersSurvey]); // eslint-disable-line react-hooks/exhaustive-deps

  const isAdmin = userInfo?.role.findIndex((p) => p === 'Administrador') > 0;
  // watch currentSurvey state
  useEffect(() => {
    if (currentSurvey !== null) {
      setChips((prevChips) => {
        const newChips = [...prevChips];

        // set chips counters
        newChips[1].counter = currentSurvey.invitados;
        newChips[2].counter = currentSurvey.respuestas;

        // personal data
        if (currentSurvey.ispersonal) {
          newChips[0].text = 'Encuesta personalizada';
        } else {
          newChips[0].text = 'Encuesta anónima';
        }

        return newChips;
      });
      setVisibility(currentSurvey.response.visibleSurvey);
    }
  }, [currentSurvey]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchAllUserSurvey();
    fetchAllUserRespondent();
  }, []);

  useEffect(() => {
    reminderDaysRef.current = reminderDays;
  }, [reminderDays]);

  useEffect(() => {
    switchCheckedReminderDaysRef.current = switchChecked;
  }, [switchChecked]);

  const generateSurveyId = () => Math.floor(Math.random() * 3) + 1; // Simula un ID dinámico entre 1 y 3

  useEffect(() => {
  if (currentSurvey?.response?.qrpath) {
      setQrPath(currentSurvey.response.qrpath);
    }
  }, [currentSurvey]);

  return (
    <Box sx={{ display: 'flex' }} translate="no">
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Cierra el Snackbar automáticamente después de 6 segundos
        onClose={() => setOpenSnackbar(false)} // Función para cerrar el Snackbar
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={alertType}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Navbar />
      <IconSidebar />

      <div style={{ backgroundColor: 'white' }}>
        <div className={styles.SurveyDetailPage}>
          <div className={styles.SurveyDetailPage__content}>
            {surveysStatus === 'loading' && <MyLoader />}
            {surveysStatus === 'failed' && (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <NotFoundMessage
                  infoMessage={
                    'Esta encuesta no esta disponible para esta compañía :('
                  }
                />
                <Button onClick={handleNavigateJourney}>
                  Volver a journey
                </Button>
              </div>
            )}
            {currentSurvey !== null && surveysStatus === 'succeeded' && (
              <Box sx={{ flexGrow: 1 }}>
                {/* header */}
                <Grid item xs={12}>
                  <MyPageHeader
                    surveyId={surveyId}
                    title={<span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(currentSurvey.response.surveyName) }} />}
                    visibility={visibility}
                    setVisibility={setVisibility}
                  />
                </Grid>
                <Grid item xs={12} sx={{ px: 2, pb: 1 }}>
                  <Button
                    variant="outlined"
                    onClick={handleJarvisReview}
                    disabled={jarvisDisabled}
                    title={
                      jarvisDisabled && jarvisDiesAt
                        ? `Revisión en curso; disponible de nuevo a las ${new Date(
                            jarvisDiesAt,
                          ).toLocaleString()}`
                        : 'Enviar la encuesta a Jarvis para revisión'
                    }
                  >
                    Revisión con Jarvis
                  </Button>
                </Grid>
                {/* survey options */}
                <Grid item xs={12}>
                  <MyCard>
                    {/* options */}
                    <div className={styles.SurveyDetailPage__options}>
                      <Typography variant="body1" gutterBottom>
                        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(currentSurvey.response.surveyName) }} />
                        
                      </Typography>
                      <div className={styles.SurveyDetailPage__options__button}>
                        {isAdmin && visibilitySelectCompanies && (
                          <SelectSurveyDuplicateTemplate
                            surveyId={surveyId}
                            currentCompanyId={currentCompany}
                            handleOpenDialog={handleOpenDialog}
                            generateSurveyId={generateSurveyId}
                            handleCloseDialog={handleCloseDialog}
                          />
                        )}

                        <IconButton
                          aria-label="more"
                          id="long-button"
                          aria-controls={open ? 'long-menu' : undefined}
                          aria-expanded={open ? 'true' : undefined}
                          aria-haspopup="true"
                          onClick={handleClickMenu}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          id="long-menu"
                          MenuListProps={{
                            'aria-labelledby': 'long-button',
                          }}
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleCloseMenu}
                        >
                          {options
                            .filter(({ option }) => {
                              // Mostrar todas las opciones solo si el usuario es administrador
                              if (
                                !isAdmin &&
                                option === 'Generar plantilla (todos)'
                              ) {
                                return false; // Oculta estas opciones si no es administrador
                              }
                              return true;
                            })
                            .map(({ option, icon }) => (
                              <MenuItem
                                key={option}
                                onClick={() => handleCloseMenu(option)}
                              >
                                {icon}
                                {option}
                              </MenuItem>
                            ))}
                        </Menu>
                      </div>
                    </div>
                    {/* tags and/or counters */}
                    <Stack spacing={1} alignItems="left">
                      <Stack direction="row" spacing={1}>
                        {chips.map(
                          (
                            { id, text, backgroundColor, color, icon, counter },
                            index,
                          ) => (
                            <Chip
                              key={id}
                              onClick={
                                index === 1
                                  ? () => {
                                      // Función para el segundo elemento
                                      handleOpenDialogEmails();
                                    }
                                  : index === 2
                                    ? () => setOpenRespondentsDialog(true)
                                  : undefined
                              }
                              style={{
                                backgroundColor: backgroundColor,
                                color: color,
                              }}
                              icon={icon}
                              label={`${
                                typeof counter !== 'undefined' ? counter : ''
                              } ${text}`}
                            />
                          ),
                        )}
                        {formatearFechas(
                          currentSurvey?.response?.startDate,
                          currentSurvey?.response?.answerDate,
                        ) && (
                          <Chip
                            variant="outlined"
                            label={formatearFechas(
                              currentSurvey.response.startDate,
                              currentSurvey.response.answerDate,
                            )}
                          />
                        )}
                      </Stack>
                    </Stack>
                    {/* change status and send invitations */}
                    <div className={styles.SurveyDetailPage__sendInvitation}>
                      <div>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={showDemographicData}
                                onChange={handleChangeShowDemographicData}
                              />
                            }
                            label="Mostrar datos demográficos"
                          />
                        </FormGroup>
                      </div>
                      <div
                        className={
                          styles.SurveyDetailPage__sendInvitation__buttons
                        }
                      >
                        <Stack
                          spacing={1}
                          direction="row"
                          flexWrap="wrap"
                          justifyContent="flex-end"
                          useFlexGap
                        >
                          {currentSurvey && !currentSurvey.response.is360 && (
                            <>
                              <SendInvitationDialog
                                isPersonal={currentSurvey.ispersonal}
                                copyUrl={handleClickCopyUrl}
                                isOpen={isOpenSendMail}
                                visibility={visibility}
                                onAudienceLoaded={refrescarEncuesta}
                              />
                            </>
                          )}
                          <Button
                            onClick={openInvitationDispatchDialog}
                            startIcon={
                              isSendingInvitation ? (
                                <CircularProgress size={16} />
                              ) : (
                                <EmailIcon />
                              )
                            }
                            variant="outlined"
                            size="small"
                            disabled={!visibility || isSendingInvitation}
                            sx={{ minWidth: 0, px: 1.5 }}
                          >
                            {isSendingInvitation ? 'Enviando...' : 'Enviar invitación'}
                          </Button>
                          <Button
                            onClick={() => {
                              setDefaultDispatchMailContent();
                              handleOpenDialog(
                                generateSurveyId(),
                                `Se enviarán los recordatorios a las personas
                                cuya antigüedad sea igual o menor al número de días indicado en la casilla.
                                El valor predeterminado es 60 días, pero puedes modificarlo si lo deseas:
                                `,
                                sendReminder,
                                false,
                                true,
                                true,
                                true,
                              );
                            }}
                            startIcon={
                              isSendingReminder ? (
                                <CircularProgress size={16} />
                              ) : (
                                <ScheduleSendIcon />
                              )
                            }
                            variant="outlined"
                            size="small"
                            disabled={!visibility || isSendingReminder}
                            sx={{ minWidth: 0, px: 1.5 }}
                          >
                            {isSendingReminder ? 'Enviando...' : 'Enviar recordatorio'}
                          </Button>
                          <Snackbar
                            open={reminderSent}
                            autoHideDuration={3000}
                            onClose={handleCloseSnackbar}
                            message="Recordatorio enviado"
                          />
                          <Snackbar
                            open={linkCopied}
                            autoHideDuration={3000}
                            onClose={handleCloseSnackbar}
                            message="Enlace copiado"
                          />
                          {/* send invitation  Whatsapp
                          <SendInvitationDialogWhatsapp
                            isPersonal={currentSurvey.ispersonal}
                            copyUrl={handleClickCopyUrlWhatsApp}
                            isOpen={isOpenSendMail}
                            mailMask={currentSurvey.response.emailMAsk}
                            mailSubject={currentSurvey.response.emailSubject}
                            emailMessage={currentSurvey.response.emailMessage}
                            visibility={visibility}
                            hasWhatsApp={currentSurvey.response.hasWhatsApp}
                          />*/}
                        </Stack>
                      </div>
                    </div>

                    {/* demographic data form */}
                    {showDemographicData === true && (
                      <Box mt={3}>
                        <Divider sx={{ margin: '21px 0' }} />
                        <DemographicDataForm surveyId={Number(surveyId)} />
                      </Box>
                    )}
                  </MyCard>
                </Grid>
                {/* resume */}
                <Grid item xs={12}>
                  <MyCard>
                    <div className={styles.SurveyDetailPage__resume}>
                      <Typography variant="body1" gutterBottom>
                        Resumen de respuesta
                      </Typography>
                      <div className={styles.SurveyDetailPage__resume__share}>
                        {!currentSurvey.response.is360 && (
                          <IconButton de respuesta
                            onClick={handleClickCopyUrl}
                            disabled={!visibility}
                          >
                            <LinkIcon />
                          </IconButton>
                        )}

                        <IconButton onClick={handleClickDownload}>
                          <DownloadIcon />
                        </IconButton>
                        {!currentSurvey.response.is360 && (
                          <Button
                            onClick={handleOpen}
                            startIcon={<VisibilityIcon />}
                            disabled={!visibility}
                          >
                            Ver Código QR
                          </Button>
                        )}

                        {userInfo?.role.findIndex(
                          (p) => p === 'Administrador',
                        ) >= 0 && (
                          <Button
                            onClick={handleOpenDeleteDialog}
                            startIcon={<CleaningServicesIcon />}
                          >
                            Borrar respuestas
                          </Button>
                        )}
                      </div>
                    </div>
                  </MyCard>
                </Grid>
                {/* Modal */}
                <Modal
                  open={openModal}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box className={styles.SurveyDetailPageQR}>
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      Código QR
                    </Typography>
                    {qrPath ? (
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      Escanea el código para acceder al enlace.
                    </Typography>) : (
                      <IconButton onClick={generateCodeQR} sx={{ mt: 2 }}>
                      <p>Generar código QR</p>
                    </IconButton>
                    )}
                    <div ref={qrRef}>
                      <img
                        id="qrCodeCanvas"
                        src={qrPath}
                        alt="QR Code"
                        width={256}
                        height={256}
                      />
                    </div>
                    {qrPath &&(
                    <IconButton onClick={handleClickDownloadQR} sx={{ mt: 2 }}>
                      <p>Descargar código QR</p>
                    </IconButton>)}
                  </Box>
                </Modal>
                {/* questions */}
                <Grid item xs={12}>
                  <MyCard>
                    {currentSurvey.response.preguntas.map(
                      ({
                        questionId,
                        questionNumber,
                        questionName,
                        description,
                        options,
                      }) => (
                        <div
                          key={questionId}
                          className={styles.SurveyDetailPage__question}
                        >
                          <div style={{ display: 'flex' }}>
                            <Typography
                              className={
                                styles.SurveyDetailPage__question__number
                              }
                              variant="body1"
                              style={{ fontWeight: 'bold' }}
                              gutterBottom
                            >
                              R{questionNumber}.
                            </Typography>
                            <Box sx={{ width: 1 }}>
                              <Typography
                                variant="body1"
                                style={{
                                  fontWeight: 'bold',
                                  wordBreak: 'break-word',
                                }}
                                gutterBottom
                              >
                                {<span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(questionName) }} />}
                              </Typography>
                              <Typography
                                variant="body1"
                                style={{
                                  fontStyle: 'italic',
                                  wordBreak: 'break-word',
                                }}
                                gutterBottom
                              >
                                {<span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} />}
                              </Typography>
                              {/* answers */}
                              <div className={styles.SurveyDetailPage__answers}>
                                <Grid container spacing={2}>
                                  {options.map(
                                    ({ numberOption, optionName }) => (
                                      <Grid key={numberOption} sm={6} item>
                                        <Typography
                                          variant="body2"
                                          gutterBottom
                                        >
                                          <span
                                            className={
                                              styles.SurveyDetailPage__answers__answer
                                            }
                                          >
                                            {numberOption}
                                          </span>
                                          {optionName}
                                        </Typography>
                                      </Grid>
                                    ),
                                  )}
                                </Grid>
                              </div>
                            </Box>
                          </div>
                        </div>
                      ),
                    )}
                  </MyCard>
                </Grid>
              </Box>
            )}
          </div>
        </div>
      </div>
      {/*Dialogs */}
      <ConfirmDialog
        open={isInvitationDialogOpen}
        onClose={() => setIsInvitationDialogOpen(false)}
        onConfirm={sendInvitationDispatch}
        idSurvey={surveyId}
        message="Se enviarán las invitaciones pendientes con el siguiente mensaje."
        skipConfirmation={false}
        confirmationInput={false}
        dialogPosition="send-invitation"
        reminderDays={reminderDays}
        setReminderDays={setReminderDays}
        errorReminderDay={errorReminderDay}
        switchChecked={switchChecked}
        setSwitchChecked={setSwitchChecked}
        is360={currentSurvey?.response?.is360 || false}
        title="Enviar invitación"
        showDispatchMessage
        dispatchMessage={dispatchMessage}
        setDispatchMessage={setDispatchMessage}
        dispatchEmailMask={dispatchEmailMask}
        setDispatchEmailMask={setDispatchEmailMask}
        dispatchEmailSubject={dispatchEmailSubject}
        setDispatchEmailSubject={setDispatchEmailSubject}
        quillModules={quillModules}
      />
      <RespondentsDialog
        open={openRespondentsDialog}
        onClose={() => setOpenRespondentsDialog(false)}
        surveyId={surveyId}
        companyId={userInfo.Company}
        invitationDefaults={{
          emailMask: getDefaultDispatchEmailMask(),
          emailSubject: getDefaultDispatchEmailSubject(),
          message: getDefaultDispatchMessage(),
        }}
      />
      {Object.keys(openDialogs).map((idDialog) => (
        <ConfirmDialog
          key={idDialog}
          open={openDialogs[idDialog]?.isOpen} // Verifica si el diálogo para el id está abierto
          onClose={() => handleCloseDialog(idDialog)}
          onConfirm={openDialogs[idDialog]?.consume}
          idSurvey={surveyId}
          message={openDialogs[idDialog]?.message} // Mensaje personalizado para cada id
          skipConfirmation={openDialogs[idDialog]?.needConfirm}
          confirmationInput={openDialogs[idDialog]?.confirmationInput}
          dialogPosition={idDialog}
          reminderDays={reminderDays}
          setReminderDays={setReminderDays}
          errorReminderDay={errorReminderDay}
          switchChecked={switchChecked}
          setSwitchChecked={setSwitchChecked}
          is360={currentSurvey?.response?.is360 || false}
          canConfirm={openDialogs[idDialog]?.canConfirm}
          title={openDialogs[idDialog]?.showDispatchMessage ? 'Enviar recordatorio' : undefined}
          showDispatchMessage={openDialogs[idDialog]?.showDispatchMessage}
          dispatchMessage={dispatchMessage}
          setDispatchMessage={setDispatchMessage}
          dispatchEmailMask={dispatchEmailMask}
          setDispatchEmailMask={setDispatchEmailMask}
          dispatchEmailSubject={dispatchEmailSubject}
          setDispatchEmailSubject={setDispatchEmailSubject}
          quillModules={quillModules}
        />
      ))}

      {dialogStep === 0 && (
        <CustomDialog
          open={true}
          title="¿Qué deseas borrar?"
          onClose={() => setDialogStep(null)} // Simplemente ciérralo o ajusta según tu flujo
          content={
            <>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => handleSelectDeleteOption('all')}
              >
                Borrar todas las respuestas
              </Button>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => handleSelectDeleteOption('delete-responses')}
                style={{ marginTop: '10px' }}
              >
                Borrar respuesta por usuario
              </Button>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => handleSelectDeleteOption('delete-all-user')}
                style={{ marginTop: '10px' }}
              >
                Eliminar todos los usuarios de la encuesta
              </Button>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => handleSelectDeleteOption('delete-user')}
                style={{ marginTop: '10px' }}
              >
                Eliminar usuario de la encuesta
              </Button>
            </>
          }
        />
      )}

      {dialogStep === 1 && (
        <CustomDialog
          open={true}
          title="Seleccione los usuarios cuyas respuestas desea borrar"
          onClose={() => {
            setDialogStep(0);
            setSelectedUserIds([]); // Limpiar selección al cerrar
          }}
          onConfirm={handleDeleteAnswerUsers} // Nota el cambio en el nombre del método
          content={
            <Autocomplete
              multiple // Habilita selección múltiple
              options={respondedUsers}
              filterSelectedOptions
              getOptionLabel={(option) => option.mail}
              value={respondedUsers.filter((user) =>
                selectedUserIds.includes(user.id),
              )}
              onChange={(event, newValues) => {
                const newUserIds = newValues.map((user) => user.id);
                setSelectedUserIds(newUserIds);
              }}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    variant="outlined"
                    label={option.mail}
                    {...getTagProps({ index })}
                    color="primary"
                    size="small"
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={
                    selectedUserIds.length === 0
                      ? 'Selecciona uno o más usuarios'
                      : selectedUserIds.length === respondedUsers.length
                        ? 'Todos los usuarios han sido seleccionados'
                        : `${selectedUserIds.length} seleccionado(s) - ${
                            respondedUsers.length - selectedUserIds.length
                          } disponible(s)`
                  }
                  fullWidth
                />
              )}
              ChipProps={{
                color: 'primary',
                variant: 'outlined',
              }}
            />
          }
        />
      )}
      {dialogStep === 2 && (
        <CustomDialog
          open={true}
          title="Seleccione los usuarios que desea eliminar de la encuesta"
          onClose={() => {
            setDialogStep(0);
            setSelectedSurveyUserIds([]); // Limpiar selección al cerrar
          }}
          onConfirm={handleDeleteUsersFromSurvey} // Nota el cambio en el nombre del método
          content={
            <Autocomplete
              multiple // Habilita selección múltiple
              options={allUsersSurvey}
              getOptionLabel={(option) => option.mail}
              value={allUsersSurvey.filter((user) =>
                selectedSurveyUserIds.includes(user.id),
              )}
              onChange={(event, newValues) => {
                const newUserIds = newValues.map((user) => user.id);
                setSelectedSurveyUserIds(newUserIds);
              }}
              filterSelectedOptions // Oculta automáticamente los usuarios ya seleccionados
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    variant="outlined"
                    label={option.mail}
                    {...getTagProps({ index })}
                    color="secondary"
                    size="small"
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={
                    selectedSurveyUserIds.length === 0
                      ? 'Selecciona uno o más usuarios'
                      : selectedSurveyUserIds.length === allUsersSurvey.length
                        ? 'Todos los usuarios han sido seleccionados'
                        : `${selectedSurveyUserIds.length} seleccionado(s) - ${
                            allUsersSurvey.length - selectedSurveyUserIds.length
                          } disponible(s)`
                  }
                  fullWidth
                />
              )}
              ChipProps={{
                color: 'secondary',
                variant: 'outlined',
              }}
            />
          }
        />
      )}

      <StaticsEmails
        openDialog={openDialogEmail}
        setOpenDialog={setOpenDialogEmail}
        handleOpenDialog={handleOpenDialogEmails}
        handleCloseDialog={handleCloseDialogEmails}
      />
    </Box>
  );
};

SurveyDetailPage.propTypes = {};

SurveyDetailPage.defaultProps = {};

export default SurveyDetailPage;
